import React, { useEffect, useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import logo from '../../assets/img/black-logo.png';
import profile from '../../assets/icons/profile.png';
import favorite from '../../assets/icons/favorite.png';
import calendar from '../../assets/icons/calendar.png';
import settings from '../../assets/icons/settings.png';
import lessons from '../../assets/icons/lessons.png';
import gift from '../../assets/icons/gift.png';
import exit from '../../assets/icons/exit.png';
import contact from '../../assets/icons/contact.png';
import commonQuestions from '../../assets/icons/common-questions.png';
import about from '../../assets/icons/about.png';
import notifications from '../../assets/icons/notifications.png';

import { Container, Row, MenuIcon, Logo } from './styles';

const SideBar = ({ visible, setVisible }) => {
  const dispatch = useDispatch();
  const componentRef = useRef();
  const history = useHistory();

  useEffect(() => {
    document.addEventListener('mousedown', handleClick);
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, []);

  const handleClick = (e) => {
    if (!componentRef.current.contains(e.target)) {
      setVisible(false);
      return;
    }
  };

  const logout = () => {
    dispatch({ type: 'yoga-adm/user/logout' });
    history.push('/login');
  };

  return (
    <Container className="sidebar" visible={visible} ref={componentRef}>
      <Row>
        <MenuIcon className="menu-icon" onClick={() => setVisible(false)}>
          <div></div>
          <div></div>
          <div></div>
        </MenuIcon>

        <Logo onClick={() => history.push('/')} src={logo} alt="Worsheep" />
      </Row>

      <ul>
        <li>
          <Link to="/perfil">
            <img src={profile} alt="Ícone da tela de perfil" />
            <span>Perfil</span>
          </Link>
        </li>

        <li>
          <Link to="/assistidos">
            <img src={lessons} alt="Ícone da tela de aulas" />
            <span>Histórico</span>
          </Link>
        </li>

        <li>
          <Link to="/favoritos">
            <img src={favorite} alt="Ícone da tela de favoritos" />
            <span>Favoritos</span>
          </Link>
        </li>

        {/* <li>
          <Link to="/calendario">
            <img src={calendar} alt="Ícone da tela de calendário" />
            <span>Meu Calendário</span>
          </Link>
        </li> */}

        {/* <li>
          <Link to="/configuracao">
            <img src={settings} alt="Ícone da tela de configurações" />
            <span>Configurações</span>
          </Link>
        </li> */}

        <li>
          <Link to="/notificacoes">
            <img src={notifications} alt="Ícone da tela de notificações" />
            <span>Notificações</span>
          </Link>
        </li>

        <li>
          <Link to="/presenteie-um-amigo">
            <img src={gift} alt="Ícone da tela de presentear" />
            <span>Presentear</span>
          </Link>
        </li>

        {/* <li>
          <Link to="/sobre-nos">
            <img src={about} alt="Ícone da tela de informações do YouMaster" />
            <span>Sobre</span>
          </Link>
        </li> */}

        <li>
          <Link to="/perguntas-frequentes">
            <img
              src={commonQuestions}
              alt="Ícone da tela de perguntas frequentes"
            />
            <span>Perguntas frequentes</span>
          </Link>
        </li>

        {/* <li>
          <Link to="/contato">
            <img src={contact} alt="Ícone da tela de fale conosco" />
            <span>Fale conosco</span>
          </Link>
        </li> */}

        <li onClick={() => logout()}>
          <img src={exit} alt="Ícone de sair do Worsheep" />
          <span>Sair</span>
        </li>
      </ul>
    </Container>
  );
};

export default SideBar;
